// About.jsx
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { IMG } from '../../data/siteData';
import './About.css';

export default function AboutIntro() {
  return (
    <section className="section about-intro">
      <div className="container about-intro__grid">
        <div
          className="about-intro__media"
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 1 }}
        >
          <img src={IMG.aerialSand} alt="Aerial view of Ambadykannan Transport fleet at a material yard" loading="lazy" />
          <div className="about-intro__badge glass">
            <span>16+</span>
            <p>Years Hauling Kerala &amp; Tamil Nadu</p>
          </div>
        </div>

        <div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.9 }}
        >
          <p className="eyebrow">Who We Are</p>
          <h2 className="section-title">Built On The Highway,<br />Trusted In Every Yard.</h2>
          <p className="about-intro__text">
            Ambadykannan Transport started as a single-truck operation and grew into a
            cross-state freight network by keeping one promise: the load arrives when we
            say it will. Today our fleet moves everything from construction material to
            long-distance commercial freight across Kerala and Tamil Nadu.
          </p>
          <p className="about-intro__text">
            Every driver, dispatcher, and loader on our team understands one thing — heavy
            transport is a trust business first, and a trucking business second.
          </p>
          <Link to="/about" className="about-intro__link">
            Our Story <FaArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
}